export const messages = {
  en: {
    dictManage: {
      queryCondition: 'Query Condition',
      dictInfo: 'Dictionary Information',
      dictType: 'Dictionary Type',
      name: 'Name',
      value: 'Value',
      description: 'Description',
      operation: 'Operation',
      selectType: 'Select Type',
      inputName: 'Please input name',
      inputValue: 'Please input value',
      inputNameRequired: 'Required, please input name',
      inputValueRequired: 'Required, please input value',
      inputDescRequired: 'Required, please input description',
      query: 'Query',
      reset: 'Reset',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      addDict: 'Add Dictionary',
      editDict: 'Edit Dictionary',
      confirmOperation: 'Please confirm your operation',
      confirmDeleteDict: 'Confirm to delete dictionary?',
      confirmDelete: 'Confirm Delete',
      cancel: 'Cancel',
      save: 'Save',
      type: 'Type',
      typeRequired: 'Type is required',
      nameRequired: 'Name is required',
      nameMaxLength: 'Name cannot exceed 50 characters',
      valueRequired: 'Value is required',
      valueMaxLength: 'Value cannot exceed 64 characters',
      descRequired: 'Description is required',
      descMaxLength: 'Description cannot exceed 200 characters',
      addSuccess: 'Add successfully',
      editSuccess: 'Edit successfully',
      deleteSuccess: 'Delete successfully'
    }
  },
  zh: {
    dictManage: {
      queryCondition: '查询条件',
      dictInfo: '字典信息',
      dictType: '字典类型',
      name: '名称',
      value: '值',
      description: '描述',
      operation: '操作',
      selectType: '请选择类型',
      inputName: '请输入名称',
      inputValue: '请输入值',
      inputNameRequired: '必填，请输入名称',
      inputValueRequired: '必填，请输入值',
      inputDescRequired: '必填，请输入描述',
      query: '查询',
      reset: '重置',
      add: '添加',
      edit: '修改',
      delete: '删除',
      addDict: '添加字典',
      editDict: '修改字典',
      confirmOperation: '请确认您的操作',
      confirmDeleteDict: '确定删除字典？',
      confirmDelete: '确认删除',
      cancel: '取消',
      save: '保存',
      type: '类型',
      typeRequired: '类型不能为空',
      nameRequired: '名称不能为空',
      nameMaxLength: '名称不能超过50个字符',
      valueRequired: '值不能为空',
      valueMaxLength: '值不能超过64个字符',
      descRequired: '描述不能为空',
      descMaxLength: '描述不能超过200个字符',
      addSuccess: '添加成功',
      editSuccess: '修改成功',
      deleteSuccess: '删除成功'
    }
  }
}